import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {InterfaceEventsEnum, trackInterfaceEvent} from '../../../../services/tracking';
import {EmojiDropdownContainer} from '../../../common/dropdowns/emoji/emojiDropdownContainer';
import {CommentComposerIcon} from './commentComposerIcon';

/*
 * Props.
 */

interface CommentComposerEmojiProps {
  conversationId: number | undefined;
  isDisabled?: boolean;
  onEmojiSelect?: HandlerOf<string>;
  onEmojiDropdownOpen: HandlerOf<boolean | undefined>;
}

/*
 * Component.
 */

export const CommentComposerEmoji: FC<CommentComposerEmojiProps> = (props) => {
  const onPopoverToggle: HandlerOf<boolean> = (isOpen) => {
    props.onEmojiDropdownOpen(isOpen);

    if (!isOpen) {
      return;
    }

    trackInterfaceEvent(InterfaceEventsEnum.COMMENT_COMPOSER_EMOJI_ICON_CLICK, {
      conversation_id: props.conversationId,
    });
  };

  return (
    <PopoverCoordinator
      shouldPreventMouseDown
      isDisabled={props.isDisabled}
      renderButton={(isOpen) => renderButton(isOpen, props.isDisabled)}
      renderModal={(modalProps) => renderDropdown(modalProps, props.onEmojiSelect)}
      onPopoverToggle={onPopoverToggle}
    />
  );
};

/*
 * Button.
 */

function renderButton(isOpen: boolean, isDisabled: boolean | undefined) {
  return (
    <CommentComposerIcon
      iconName="emojiSmall"
      isDisabled={isDisabled}
      hasHover={isOpen}
      renderTooltip={() => !isDisabled && <Trans id="comment-composer-emoji">Insert emoji</Trans>}
    />
  );
}

/*
 * Dropdown.
 */

function renderDropdown(modalProps: PopoverTransferProps, onEmojiSelect?: HandlerOf<string>) {
  return (
    <EmojiDropdownContainer
      {...modalProps}
      placement="top-end"
      onEmojiSelect={modalProps.wrap(onEmojiSelect)}
    />
  );
}
